export default {"src":"/_next/static/media/Crop-Stumps_Miscanthus.2928f540.svg","height":337,"width":272,"blurWidth":0,"blurHeight":0};